







































import { getToken } from '@/utils/cookie';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class HeaderSmall extends Vue {
  headerId = 'SMALL_HEADER';

  get currentPage() {
    return this.$route.path;
  }

  @Prop()
  showMenu: boolean;

  isLoggedin = false;
  prevScrollpos = window.pageYOffset;

  get isMoreActive() {
    return this.showMenu;
  }

  links = [
    {
      name: 'Bina Latihan',
      isActive: false,
      isFocus: false,
      path: '/papers',
      isPrivate: true,
      isPublic: true,
    },
    {
      name: 'Set Latihan',
      isActive: false,
      isFocus: false,
      path: '/browse',
      isPrivate: true,
      isPublic: true,
    },
    {
      name: 'Blog',
      isActive: false,
      isFocus: false,
      path: '/blog',
      isPrivate: true,
      isPublic: true,
    },
  ];

  created() {
    window.addEventListener('scroll', this.scrollBottom);
    this.updateLink();
  }

  linkClicked(path: string) {
    this.$sendMpEvent({
      event: this.$mp_value.SmallHeaderClick,
      properties: {
        path: path,
      },
    });

    if (path !== this.currentPage) {
      this.$router.replace({ path });
    }

    this.$emit('updateShowMenu', false);
    this.updateLink();
  }

  @Watch('currentPage')
  onPageChanged() {
    this.$emit('updateShowMenu', false);
    this.updateLink();
  }

  @Watch('showMenu')
  onShowMenu() {
    this.updateLink();
  }

  updateLink() {
    let hasActiveLink = false;
    this.isLoggedin = getToken() ? true : false;

    this.links.forEach(link => {
      if (this.currentPage.includes(link.path) && !this.showMenu) {
        link.isActive = true;
        hasActiveLink = true;
      } else {
        link.isActive = false;
      }
    });

    const signupLink = this.links.find(link => link.name === 'Signup');

    if (signupLink) {
      if (hasActiveLink) {
        signupLink.isFocus = false;
      } else {
        signupLink.isFocus = true;
      }
    }
  }

  moreClicked() {
    this.$sendMpEvent({
      event: this.$mp_value.SmallHeaderClick,
      properties: {
        path: '/more',
      },
    });

    this.$emit('updateShowMenu', true);
    this.updateLink();
  }

  scrollBottom() {
    const currentScrollPos = window.pageYOffset;
    const header = document.getElementById(this.headerId);
    const mainHeader = document.getElementById('MAIN_HEADER');
    if (header && mainHeader) {
      if (
        this.isInViewport(mainHeader) ||
        this.prevScrollpos > currentScrollPos
      ) {
        header.style.bottom = '0';
      } else {
        header.style.bottom = '-50px';
      }
    }
    this.prevScrollpos = currentScrollPos;
  }

  isInViewport(element: any) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
